import Bus from "@/plugins/bus";
export default {
  Bus,
};
